import React from 'react'

import { isInViewport } from 'utils/misc'

export const useIsVisible = (
  wrapperRef: React.RefObject<HTMLDivElement>,
  element: HTMLElement | Window = window,
) => {
  const checkIsInViewport = React.useCallback(() => {
    return wrapperRef.current ? isInViewport(wrapperRef.current) : false
  }, [wrapperRef])

  const [isInputInViewport, setInputInViewport] = React.useState(true)

  const handleToolbarVisibility = React.useCallback(() => {
    setInputInViewport(checkIsInViewport())
  }, [checkIsInViewport])

  React.useEffect(() => {
    element.addEventListener('scroll', handleToolbarVisibility, true)
    return () => {
      element.removeEventListener('scroll', handleToolbarVisibility, true)
    }
  }, [handleToolbarVisibility, isInputInViewport, element])

  return isInputInViewport
}
